export function buildInPersonSigningUrl(
  participantSigningUrl,
  inPersonUrl,
  signingUrlOverride
) {
  const signingUrl = new URL(participantSigningUrl);

  if (signingUrlOverride) {
    const overrideUrl = new URL(signingUrlOverride);
    signingUrl.protocol = overrideUrl.protocol;
    signingUrl.host = overrideUrl.host;
  }

  if (signingUrl.searchParams.has('d') && signingUrl.pathname !== '/signing') {
    signingUrl.pathname = '/signing';
  }

  signingUrl.searchParams.set('inPersonUrl', inPersonUrl);

  return signingUrl.toString();
}



// WEBPACK FOOTER //
// ./src/inPersonSigningUrl.js